import { Link } from "react-router-dom"
import projectsData from "../data/dataJson"
export default function Projects() {
  return (
    <section id="projects" className="py-20 mx-auto max-w-7xl px-6">

      <div className="text-center mb-12">
        <h2 className="font-display text-4xl font-bold text-white tracking-wide">
          My Projects
        </h2>
      </div>

      <div className="flex flex-wrap justify-center gap-6">
        {projectsData.map((project) => (
          <div
            key={project.id}
            className="ui-card ui-card-interactive p-5 flex flex-col w-full sm:w-[calc(50%-1.5rem)] lg:w-[calc(25%-1.5rem)] min-w-[280px] max-w-[350px]"
          >

            <h3 className="font-body text-lg font-bold text-white mb-2">
              {project.title}
            </h3>

            <p className="font-body text-sm text-slate-400 leading-relaxed mb-6 flex-grow">
              {project.description}
            </p>
            <Link to={project.link}>
              <button className="self-start px-5 py-2 rounded-full border border-slate-700 bg-slate-800/50 text-xs font-semibold text-white hover:border-cyan-400 hover:text-cyan-400 hover:bg-cyan-500/10 transition-all">
                View Project
              </button>
            </Link>
          </div>
        ))}
      </div>

    </section>
  );
}